export const speak = [
  {
    keyword: 'call',
    description: 'List your officials and their phone numbers',
  },
  {
    keyword: 'coauthor',
    description:
      'Have the bot write a letter for you about a bill or news article',
  },
  {
    keyword: 'following',
    description:
      'See <a className="anchor-text" href="/petitions">petitions</a> created by organizers you follow',
  },
  {
    keyword: 'review',
    description: 'Submit a public review of your elected officials',
  },
  {
    keyword: 'sign',
    description:
      'Text before a <a className="anchor-text" href="/petitions/PUCZGE">petition code</a> to send it to your officials',
  },
  {
    keyword: 'trending',
    description:
      'See what <a className="anchor-text" href="/petitions">petitions</a> are trending right now',
  },
  {
    keyword: 'visit',
    description:
      'Visit the capitol or local offices for your federal officials',
  },
  {
    keyword: 'write',
    description: 'Write a letter to your officials',
  },
];

export const targets = [
  {
    keyword: 'all',
    description: 'President, U.S. Congress, Governors & Legislators',
  },
  {
    keyword: 'federal',
    description: 'The President & U.S. Congress',
  },
  {
    keyword: 'state',
    description: 'State Governors and/or Legislators',
  },
  {
    keyword: 'congress',
    description: 'U.S. Senate & U.S. House of Representatives',
    suggested: true,
  },
  {
    keyword: 'senate',
    description: 'U.S. Senate',
  },
  {
    keyword: 'house',
    description: 'U.S. House of Representatives',
  },
  {
    keyword: 'court',
    description: 'The U.S. Supreme Court',
  },
  {
    keyword: 'president',
    description: 'The President of the United States',
  },
  {
    keyword: 'vice',
    description: 'The Vice President of the United States',
  },
  {
    keyword: 'senior',
    description: 'Senior U.S. Senator',
  },
  {
    keyword: 'junior',
    description: 'Junior U.S. Senator',
  },
  {
    keyword: 'gov',
    description: 'Governor',
  },
  {
    keyword: 'legislature',
    description: 'State Senate & House',
  },
  {
    keyword: 'upper',
    description: 'State Senate',
  },
  {
    keyword: 'lower',
    description: 'State House',
  },
  {
    keyword: 'ceo',
    description:
      'Chief Election Official (Sec. of State, Lt. Gov., or Election Dir.)',
  },
  {
    keyword: 'mayor',
    description: 'City or County Mayor',
  },
];

export const vote = [
  {
    keyword: 'check',
    description: 'Check your voter registration',
  },
  {
    keyword: 'election',
    description: 'Find your local (usually county) election office',
  },
  {
    keyword: 'polling',
    description: 'Find early vote sites, ballot dropboxes & polling places',
  },
  {
    keyword: 'track',
    description: 'Track your early or mail-in ballot',
  },
];

export const volunteer = [
  {
    keyword: 'claim',
    description:
      'Claim your <a className="anchor-text" href="/news/2021/05/06/build-your-following">own keyword</a> and amass followers',
  },
  {
    keyword: 'earn',
    description: 'Earn coins for reading campaigns promoted by other members',
  },
  {
    keyword: 'import',
    description:
      'Turn your <a className="anchor-text" href="/news/2020/09/17/launch-your-action-network-petitions-on-resistbot">Action Network petition</a> into a Resistbot campaign',
  },
  {
    keyword: 'image',
    description: 'Get an image of your last letter to share',
  },
  {
    keyword: 'image pccpgw',
    description:
      'Text before a petition code to get a shareable image for any petition (e.g., PCCPGW)',
  },
  {
    keyword: 'image check',
    description:
      'Text before a keyword to get a shareable image for any keyword (e.g., CHECK)',
  },
  {
    keyword: 'invite',
    description:
      'Text before a campaign code (e.g., PCCPGW) invite someone to sign a campaign, earn 50 coins for every first-time sender invited by SMS',
    suggested: true,
  },
  {
    keyword: 'moms',
    description:
      'Find local <a className="anchor-text" href="https://momsdemandaction.org">Moms Demand Action</a> events',
  },
  {
    keyword: 'petition',
    description:
      'Make your last letter a signable <a className="anchor-text" href="/petitions">petition</a>',
  },
  {
    keyword: 'petitions',
    description: 'See petitions you’ve already created',
  },
  {
    keyword: 'promote',
    description:
      'Spend coins to <a className="anchor-text" href="/news/2021/05/18/introducing-rewarded-alerts">promote your petition</a> or vote drive to other Resistbot members',
  },
  {
    keyword: 'protest',
    description: 'Find nearby rallies or protests',
  },
  {
    keyword: 'run',
    description:
      'Find local elected offices to run for with <a className="anchor-text" href="https://www.runforsomething.net">Run for Something</a>',
  },
  {
    keyword: 'volunteer',
    description:
      'Find local canvassing, club meetings, phone banks, and other organizing events near you',
  },
];

export const educate = [
  {
    keyword: 'abortion',
    description:
      'See abortion policies in your state after the overturning of Roe v. Wade',
  },
  {
    keyword: 'bills',
    description: 'See upcoming bills in the U.S. House',
  },
  {
    keyword: 'guns',
    description:
      'See how much gun rights and gun safety groups have spent on your representatives',
  },
  {
    keyword: 'native',
    description: 'See what native lands you’re currently occupying',
  },
  {
    keyword: 'NRA',
    description:
      'See how much the gun manufacturers lobby has spent for/against your representatives',
  },
  {
    keyword: 'page',
    description: 'Get up to three newspaper front pages delivered daily',
  },
];

export const account = [
  {
    keyword: 'account',
    description: 'Change your name, address, prefix/title, or email',
    suggested: true,
  },
  {
    keyword: 'alerts',
    description: 'Manage what texts/alerts the bot can send you',
  },
  {
    keyword: 'buy',
    description:
      '<a className="anchor-text" href="/premium/coins">Buy coins</a> to spend on faxes, postage, and promotions',
  },
  {
    keyword: 'close',
    description:
      'Text before a petition code (e.g., PCCPGW) to close, and optionally delete a, petition',
  },
  {
    keyword: 'coins',
    description: 'See how many coins you have',
  },
  {
    keyword: 'edit',
    description:
      'Text before a petition code (e.g., PCCPGW) to edit a petition',
  },
  {
    keyword: 'follow',
    description:
      'Text before a username (e.g., JESSCRAVEN101) to get text updates from that organizer',
  },
  {
    keyword: 'join',
    description:
      'Become a <a className="anchor-text" href="/premium">premium member</a> and unlock more features',
  },
  {
    keyword: 'login',
    description: 'Log in to Resistbot on the web',
  },
  {
    keyword: 'organizers',
    description: 'See which organizers you’re following',
  },
  {
    keyword: 'premium cancel',
    description: 'Cancel your premium membership',
  },
  {
    keyword: 'premium change',
    description: 'Change the payment method attached to your account',
  },
  {
    keyword: 'prefs',
    description: 'Change bot behaviors',
  },
  {
    keyword: 'stats',
    description: 'See your usage stats and followers',
  },
  {
    keyword: 'stop',
    description: 'Cancel the service completely',
  },
  {
    keyword: 'unfollow',
    description: 'Use before a username (e.g., ROSIE) to unfollow an organizer',
  },
  {
    keyword: 'unsign',
    description:
      'Text before a petition code (e.g., PCCPGW) to unsign a petition',
  },
];

export const community = [
  {
    keyword: 'blood',
    description: 'Local non-profit community blood centers',
  },
  {
    keyword: 'csa',
    description: 'Community-Supported Agriculture near you',
  },
  {
    keyword: 'food',
    description: 'Food banks near you',
  },
  {
    keyword: 'mutual aid',
    description: 'Mutual aid networks near you',
  },
];

export const allCommands = [
  ...account,
  ...community,
  ...educate,
  ...speak,
  ...volunteer,
  ...vote,
];

export const allSections = {
  speak,
  vote,
  volunteer,
  educate,
  community,
  account,
};

export const allCommandsByName = new Map();

for (const [section, commands] of Object.entries(allSections)) {
  for (const command of commands) {
    allCommandsByName.set(command.keyword, { command, section });
  }
}
